/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VoucherService } from '@app/modules/core/services/vouchers/vouchers.service';
import { BookingState } from '@app/modules/core/states/booking-state/booking.state';
import { OfferStateModel } from '@app/modules/core/states/offer-state/offer.model';
import { BookingData } from '@app/modules/home/models/booking-data.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { AuthenticationService } from 'rest-client';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ChangeDetectorRef } from '@angular/core';


@UntilDestroy()
@Component({
  selector: 'bkg-voucher-banner',
  templateUrl: './voucher-banner.component.html',
  styleUrls: ['./voucher-banner.component.scss'],

})
export class VoucherBannerComponent implements OnInit, OnDestroy {
  @Select(BookingState.bookingData) bookingData$: Observable<BookingData>;

  isExpanded = false;
  private destroy$ = new Subject<void>();

  @Input() offerData: OfferStateModel;

  @Output() addVoucherCodeReturn = new EventEmitter<string>();
  selectedVoucherCode: string | null = null;
  availableVouchers: any;
  availableVouchersLength: number = 0;
  constructor(
    private authService: AuthenticationService,
    private voucherService: VoucherService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }


  ngOnInit(): void {
    this.fetchClientVouchers();
    this.subscribeToAvailableVouchers();
    this.voucherService.selectedVoucherCode$
      .pipe(takeUntil(this.destroy$))
      .subscribe((code) => {
        this.selectedVoucherCode = code;
      });
  }


  toggleCoupons() {
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }

  subscribeToAvailableVouchers(): void {
    this.bookingData$
      .pipe(untilDestroyed(this))
      .subscribe((bookingData) => {
        if (!bookingData?.startDate || !bookingData?.endDate) {
          console.warn('Fechas no disponibles en bookingData');
          return;
        }

        const data = {
          start_date: bookingData.startDate,
          end_date: bookingData.endDate,
          id_lot: bookingData.product?.idLot || 0,
          id_product: bookingData.product?.id || 0,
        };

        this.availableVouchers = this.voucherService.listAvailableVouchers(data);
        this.availableVouchersLength = this.availableVouchers.length;
      });
  }

  fetchClientVouchers() {
    if (this.authService.isTokenValid() && this.authService.isClient()) {
      {
        this.voucherService
          .fetchClientVouchers()
          .pipe(untilDestroyed(this))
          .subscribe();
      }
    }
  }

  onCouponSelected(code: string): void {
    setTimeout(() => {
      this.toggleCoupons();
    }, 250);
    if (this.selectedVoucherCode === code) return;
    this.selectedVoucherCode = code;
    this.voucherService.setSelectedVoucherCode(code);
    //this.addVoucherCodeReturn.emit(this.selectedVoucherCode);
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  get showVoucherBanner() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('/where-when') || currentUrl.includes('/confirmation')) return false;
    return true;
  }

}
